/**
 * Последовательное применение декораторов
 * @param fn - функция на декорирование
 * @param decorators - Функции декораторы
 */
export const flatDeco = (fn: any, ...decorators: any[]) =>
  decorators.reduce((value, decorator) => decorator(value), fn);
